import { useLocation, useNavigate } from "react-router-dom";

export const useUpdateUrlParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);

  const updateUrlParams = (params: Record<string, string>) => {
    const newParams = new URLSearchParams(location.search);

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
    });

    const newSearch = newParams.toString();
    const newUrl = newSearch
      ? `${location.pathname}?${newSearch}`
      : location.pathname;

    navigate(newUrl, { replace: true });
  };

  return { searchParams, updateUrlParams };
};
